'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 *
 * @param yCoordinate Limit in the Y axis to be tested
 * @param padding Padding of the element to be considered when tested
 * @returns Whether the page is scrolled past the limit in the Y axis
 */
var isPageScrolledPastPoint = function (yCoordinate, padding) {
    if (padding === void 0) { padding = 0; }
    return window.pageYOffset + padding >= window.pageYOffset + yCoordinate;
};
/**
 *
 * @param element Element to be tested
 * @param padding Padding to be considered in the scroll test
 * @returns Whether the page is scrolled the top of the element
 */
var isPageScrolledPastTopOfElement = function (element, padding) {
    if (padding === void 0) { padding = 0; }
    return element &&
        isPageScrolledPastPoint(element.getBoundingClientRect().top, padding);
};
/**
 *
 * @param element Element to be tested
 * @param padding Padding to be considered in the scroll test
 * @returns Whether the page is scrolled the bottom of the element
 */
var isPageScrolledPastBottomOfElement = function (element, padding) {
    if (padding === void 0) { padding = 0; }
    return element &&
        isPageScrolledPastPoint(element.getBoundingClientRect().bottom, -1 * padding);
};
/**
 *
 * @returns Whether the page is at the bottom of the viewport
 */
var isPageAtBottom = function () {
    return window.innerHeight + window.scrollY >= document.body.offsetHeight;
};
/**
 *
 * @param el Element to extract the styling from
 * @returns Display property of the element
 */
var getDisplayStyle = function (el) {
    return el && getComputedStyle(el, null).display;
};
/**
 *
 * @param id Id for the Element that the page will scroll to
 * @param topPadding Padding to be considered at the top limit of the element
 */
var scrollToSection = function (id, topPadding) {
    if (topPadding === void 0) { topPadding = 0; }
    var element = document.getElementById(id);
    if (element) {
        element.scrollIntoView(true);
        // now account for fixed header
        setTimeout(function () {
            if (window === null || window === void 0 ? void 0 : window.scrollY) {
                window.scroll(0, (window === null || window === void 0 ? void 0 : window.scrollY) - topPadding);
            }
        }, 500);
    }
};
var TYPE_VIDEO = 'video';
/**
 *
 * @param multimediaType Type to be checked
 * @returns Whether the type is video
 */
var isVideo = function (multimediaType) {
    return multimediaType === TYPE_VIDEO;
};
/**
 *
 * @param videoUrl Video URL to be tested to match youtube links
 * @returns Youtube url if matches or null
 */
var getYouTubeVideoId = function (videoUrl) {
    if (videoUrl === void 0) { videoUrl = ''; }
    videoUrl = videoUrl || '';
    return videoUrl.match(/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|e\/|v\/|vi\/|watch\?v=|watch\?vi=|watch\?.+&v=|watch\?.+&vi=|\?v=|\?vi=))((\w|-){11})(?:\S+)?$/)
        ? RegExp.$1
        : null;
};
/**
 *
 * @param videoUrl Video url to extract the youtube video thumbnnail
 * @returns Link to youtube video thumbnail or null
 */
var getYouTubeStill = function (videoUrl) {
    return videoUrl
        ? "https://img.youtube.com/vi/".concat(getYouTubeVideoId(videoUrl), "/0.jpg")
        : '';
};
/**
 *
 * @param img Image url to set the preset
 * @param preset Preset to be used for the image
 * @returns URL to the image with the given preset embedded
 */
var getImagePresetUrl = function (img, preset) {
    if (img === void 0) { img = ''; }
    return img ? "".concat(img === null || img === void 0 ? void 0 : img.split('?')[0], "?$").concat(preset, "$") : '';
};
/**
 *
 * @param el Container of the elements to be queried
 * @returns First element in the container that can be focused
 */
var getFirstFocusableElement = function (el) {
    return el &&
        el.querySelectorAll &&
        Array.from(el.querySelectorAll('a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')).filter(function (el) { return !el.hasAttribute('disabled'); })[0];
};
/**
 *
 * @param string String to be escaped
 * @returns String with special characters escaped
 */
var escapeRegExp = function (string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string
/**
 *
 * @param string String to be used as a template when replacing
 * @param replacements Strings to be used as replacements on tokens
 * @param encodeReplacement Whether the string should be encoded
 * @returns String used as template with replacements placed in the tokens
 */
var replaceTokens = function (string, replacements, encodeReplacement) {
    return (replacements || []).reduce(function (accumulator, currentValue, index) {
        return accumulator === null || accumulator === void 0 ? void 0 : accumulator.replace(new RegExp(escapeRegExp("{".concat(index, "}")), 'g'), encodeReplacement
            ? encodeURIComponent(currentValue !== null && currentValue !== void 0 ? currentValue : '')
            : currentValue !== null && currentValue !== void 0 ? currentValue : '');
    }, string);
};
/**
 * Replaces tokens in a string
 * @param {string} string - A string with sequential tokens to be replaced. ex: "Hello {0}! It's me {1}!"
 * @param {...string} replacements - Strings that replace a token {index-1} (the first node in replacements replaces {0}, 2nd -> {1})
 * @returns {string} - Returns a string with tokens (ex. {0}, {1}) replaced with it's corresponding replacement.
 * @example
 * 		// returns 'Hello world! It's me Keith!'
 * 		replaceTokensInString("Hello {0}! It's me {1}!", 'world', 'Keith');
 * @license - Credit https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
 * 		(Mozilla code samples added on or after August 20, 2010 are in the public domain (CC0). No licensing notice is necessary)
 */
var replaceTokensInString = function (string) {
    var replacements = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        replacements[_i - 1] = arguments[_i];
    }
    return replaceTokens(string, replacements, false);
};

exports.escapeRegExp = escapeRegExp;
exports.getDisplayStyle = getDisplayStyle;
exports.getFirstFocusableElement = getFirstFocusableElement;
exports.getImagePresetUrl = getImagePresetUrl;
exports.getYouTubeStill = getYouTubeStill;
exports.getYouTubeVideoId = getYouTubeVideoId;
exports.isPageAtBottom = isPageAtBottom;
exports.isPageScrolledPastBottomOfElement = isPageScrolledPastBottomOfElement;
exports.isPageScrolledPastPoint = isPageScrolledPastPoint;
exports.isPageScrolledPastTopOfElement = isPageScrolledPastTopOfElement;
exports.isVideo = isVideo;
exports.replaceTokens = replaceTokens;
exports.replaceTokensInString = replaceTokensInString;
exports.scrollToSection = scrollToSection;
//# sourceMappingURL=utilityFunctions.js.map
